<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.rolling_values_title') }}
    </h1>

    <v-data-table
      :headers="headers"
      :items="rollingValues.data"
      class="elevation-1"
      :pagination.sync="pagination"
      item-key="_id"
    >
      <template v-slot:headers="props">
        <tr>
          <th />
          <th
            colspan="3"
            class="milk"
          >
            milk
          </th>
          <th
            colspan="4"
            class="feed"
          >
            feed
          </th>
        </tr>
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="header.class"
          >
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="header.text" />
          </th>
        </tr>
      </template>

      <template v-slot:items="row">
        <td class="text-xs-center">
          {{ row.item.date | formatDate }}
        </td>
        <td class="text-xs-center milk">
          {{ row.item.guaranteedMilkPrices.protein | euro }}
        </td>
        <td class="text-xs-center milk">
          {{ row.item.guaranteedMilkPrices.fat | euro }}
        </td>
        <td class="text-xs-center milk">
          {{ row.item.guaranteedMilkPrices.lactose | euro }}
        </td>
        <td class="text-xs-center feed">
          {{ row.item.guaranteedFeedPrices.KVEMPriceInMill | eurocent }}
        </td>
        <td class="text-xs-center feed">
          {{ (row.item.guaranteedFeedPrices.KVEMPriceInMill / 10) | euro }}
        </td>
        <td class="text-xs-center feed">
          {{ row.item.guaranteedFeedPrices.KDVEPriceInMill | eurocent }}
        </td>
        <td class="text-xs-center feed">
          {{ (row.item.guaranteedFeedPrices.KDVEPriceInMill / 10) | euro }}
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          fab
          fixed
          bottom
          right
          dark
          class="mb-4"
          v-on="on"
        >
          <v-icon dark>
            add
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('message.add_rolling_value') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="rollingValue.date"
                      :label="$t('message.rolling_val_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="rollingValue.date"
                    @input="dateMenu = false"
                  />
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="rollingValue.guaranteedMilkPrices.protein"
                  :label="$t('message.rolling_val_protein')"
                  prefix="€"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="rollingValue.guaranteedMilkPrices.fat"
                  :label="$t('message.rolling_val_fat')"
                  prefix="€"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="rollingValue.guaranteedMilkPrices.lactose"
                  :label="$t('message.rolling_val_lactose')"
                  prefix="€"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="
                    rollingValue.guaranteedFeedPrices.KVEMPriceInMill
                  "
                  :label="
                    $t('message.rolling_val_KVEMPriceInMill').replace(
                      '<br>',
                      ' '
                    )
                  "
                  prefix="¢"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="
                    rollingValue.guaranteedFeedPrices.KDVEPriceInMill
                  "
                  :label="
                    $t('message.rolling_val_KDVEPriceInMill').replace(
                      '<br>',
                      ' '
                    )
                  "
                  prefix="¢"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="darken-1"
            flat
            @click="closeDialog"
          >
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
            color="secondary"
            @click="save"
          >
            {{ $t('message.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Targets',
  data: (vm) => ({
    headers: [
      { text: vm.$t('message.rolling_val_date'), value: 'date', class: '' },
      {
        text: vm.$t('message.rolling_val_protein'),
        value: 'protein',
        sortable: false,
        class: 'milk',
      },
      {
        text: vm.$t('message.rolling_val_fat'),
        value: 'fat',
        sortable: false,
        class: 'milk',
      },
      {
        text: vm.$t('message.rolling_val_lactose'),
        value: 'lactose',
        sortable: false,
        class: 'milk',
      },
      {
        text: vm.$t('message.rolling_val_KVEMPriceInMill'),
        value: 'KVEMPriceInMill',
        sortable: false,
        class: 'feed',
      },
      {
        text: vm.$t('message.rolling_val_KVEMPriceInEuro'),
        value: 'KVEMPriceInMill',
        sortable: false,
        class: 'feed',
      },
      {
        text: vm.$t('message.rolling_val_KDVEPriceInMill'),
        value: 'KDVEPriceInMill',
        sortable: false,
        class: 'feed',
      },
      {
        text: vm.$t('message.rolling_val_KDVEPriceInEuro'),
        value: 'KDVEPriceInMill',
        sortable: false,
        class: 'feed',
      },
    ],
    dialog: false,
    editedIndex: -1,
    rollingValue: {
      date: new Date().toISOString().substr(0, 10),
      guaranteedMilkPrices: {},
      guaranteedFeedPrices: {},
    },
    dateMenu: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: -1, // -1 for All",
      sortBy: 'date',
    },
  }),
  computed: {
    ...mapState(['rollingValues']),
  },
  created() {
    this.$store.dispatch('getRollingValues')
  },
  methods: {
    save: function () {
      ;['protein', 'fat', 'lactose'].forEach((key) => {
        this.rollingValue.guaranteedMilkPrices[key] =
          this.rollingValue.guaranteedMilkPrices[key] * 100
      }) // ; needed!
      ;['KVEMPriceInMill', 'KDVEPriceInMill'].forEach((key) => {
        this.rollingValue.guaranteedFeedPrices[key] =
          this.rollingValue.guaranteedFeedPrices[key] * 10
      })
      this.$store.dispatch('saveRollingValues', this.rollingValue)
      this.closeDialog()
    },
    closeDialog: function () {
      this.dialog = false
      this.rollingValue = {
        date: new Date().toISOString().substr(0, 10),
        guaranteedMilkPrices: {},
        guaranteedFeedPrices: {},
      }
    },
  },
}
</script>
<style>
.milk {
  background-color: #cce2f7;
}
.feed {
  background-color: #d8e674;
}
</style>
